import { Utils } from '@Util/utils'
import './styles.scss'

export type TicketSummaryProps = {
  totalWinnings: number
  pendingGames: number
}

const CLASS_NAME = `ticket-summary`

export const TicketSummary = (props: TicketSummaryProps) => {
  return (
    <div className={`${CLASS_NAME}`}>
      <div className={`${CLASS_NAME}__section`}>
        <div className={`${CLASS_NAME}__amount`}>
          {Utils.convertCentsNumberToDollarString(props.totalWinnings)}
        </div>
        <div className={`${CLASS_NAME}__label`}>Total Winnings</div>
      </div>
      <div className={`${CLASS_NAME}__section`}>
        <div className={`${CLASS_NAME}__amount`}>{props.pendingGames}</div>
        <div className={`${CLASS_NAME}__label`}>Pending Games</div>
      </div>
    </div>
  )
}
